import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { IntlProvider } from 'react-intl';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import { UserProvider } from './contexts/UserContext';
import { LOCALES, FORMATS } from './i18n/locales';
import { queryClient } from './services/queryClient';
import { sentryInitializer } from './utils/sentryInitializer';

import './index.css';
import 'src/styles/global.scss';

const { REACT_APP_GTM_ID: GTM_ID } = process.env;

const tagManagerArgs = {
  gtmId: GTM_ID,
};

TagManager.initialize(tagManagerArgs);

sentryInitializer();

// may be defined via environment variable in the future
const defaultLocale = LOCALES.PT_BR;

const Index = () => (
  <IntlProvider
    locale={defaultLocale}
    defaultLocale={defaultLocale}
    formats={FORMATS[defaultLocale]}
    defaultFormats={FORMATS[defaultLocale]}
  >
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <Router>
          <App />
        </Router>
      </UserProvider>
    </QueryClientProvider>
  </IntlProvider>
);

const root = createRoot(document.getElementById('root'));
root.render(<Index />);
